import { ActionTypes } from "../constants/action-types"

const initialState = {
    updateFaq:[]

}

export const UpdateFaqById = (state=initialState, {type, payload})=>{
switch (type){
    case ActionTypes.EDIT_FAQ: 
    return {...state, updateFaq: payload}
    default: return state
}

}